import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

interface BorderBeamProps {
  children: React.ReactNode;
  className?: string;
  size?: number;
  duration?: number;
  borderWidth?: number;
  colorFrom?: string;
  colorTo?: string;
  delay?: number;
}

export function BorderBeam({
  children,
  className,
  size = 200,
  duration = 15,
  borderWidth = 1.5,
  colorFrom = '#0000FF',
  colorTo = '#60A5FA',
  delay = 0,
}: BorderBeamProps) {
  return (
    <div className={cn('relative', className)}>
      {children}
      
      {/* Animated border beam */}
      <motion.div
        className="pointer-events-none absolute inset-0 rounded-xl"
        style={{
          padding: `${borderWidth}px`,
          background: `linear-gradient(90deg, ${colorFrom}, ${colorTo}, ${colorFrom})`,
          WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
          WebkitMaskComposite: 'xor',
          maskComposite: 'exclude',
        }}
        initial={{ opacity: 0 }}
        animate={{
          opacity: [0, 0.5, 0],
          backgroundPosition: ['0% 50%', '100% 50%', '0% 50%'],
        }}
        transition={{
          duration,
          repeat: Infinity,
          delay,
          ease: 'linear',
        }}
      />
    </div>
  );
}

